<template>

    <v-navigation-drawer v-if="load && dataLoad && assetInfo"
        v-model="drawer" 
        right
        app
        style="height: 100vh;"
        :width="260"
        >

        <div style="display: fixed;margin-top: 64px;">
            <div>
            <v-btn
                small
                outlined
                @click="drawer_Btn"
                class="drawer_btn"
                style="min-width: 20px;padding: 2px;height: 40px;border-radius: 6px 0px 0px 6px;"
                >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>
        
        <v-list-item>
            <v-list-item-content>
            <v-list-item-title><h3>{{ $store.getters.t('원본 영상') }}</h3></v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <!-- <div class="imageInfo-container ma-3">
            <v-img :src="getImage" class="imageInfo" >
                <v-icon v-ripple @click="openPlayer">mdi-play</v-icon>
            </v-img>
        </div> -->
        <v-list-item>
        <div class="imageInfo-container">
            <v-img :src="getImage" style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;" :contain="true">
                <div class="overlay">
                    <v-icon v-if="stateCheck" style="font-size: 50px;" @click="openPlayer">mdi-play-circle</v-icon>
                </div>
                <div class="overlay_wrap" v-if="codecCheck()" >
                    <div class="overlay">
                        <!-- <v-icon v-bind="attrs" v-on="on" color="error" class="mr-2">mdi-alert-circle</v-icon> -->
                        <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                        <span style="color: #ffffff;font-size:12px">{{ $store.getters.t('인코딩 후 영상 재생이 가능합니다.') }}</span>
                    </div>
            </div>
                <!-- <v-icon  @click="openPlayer" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); font-size: 48px;">mdi-play</v-icon> -->
            </v-img>
        </div>
        </v-list-item>

     

        <v-list-item>
            <v-list-item-content>
            <v-list-item-title><h3>{{ $store.getters.t('영상 상세 정보') }}</h3></v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <div class="ml-4">
            <table style="width: 92%; table-layout: fixed;border-top: 1px solid #000;">
                <thead>
                <tr class="table_wrap">
                    <th class="text-left table_title pa-3"
                    style="
                    color: #000;
                    font-size: 14px;"
                    >
                        {{ $store.getters.t('이름') }}
                    </th>
                    <th class="text-left table_text pa-3"
                    style="
                    font-size: 14px;
                    font-weight:400;
                    ">
                        <span class="text_box" >{{ assetInfo.name }}</span>
                    </th>
                </tr>
            </thead>
            </table>
            
        </div>

        <v-simple-table class="pa-4 pt-0">
    <template>
        <thead>
            <tr class="table_wrap">
                <th class="text-left table_title pa-3"
                style="
                color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('재생시간') }}
                </th>
                <th class="text-left table_text"
                style="
                font-size: 14px;
                font-weight:400;">
                    <span> {{ assetInfo.runtime }}</span>
                </th>
                
            </tr>
                
            <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('원본 해상도') }}
                </th>
                <th class="text-left table_text"
                style="font-size: 14px;
                font-weight:400;">
                    <span> {{ assetInfo.upload_resolution }}</span>
                </th>
            </tr>

            <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('등록일') }}
                </th>
                <th class="text-left table_text"
                style="font-size: 14px;
                font-weight:400;">
                    <span> {{ assetInfo.upload_time }}</span>
                </th>
            </tr>
            <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('인코딩') }}
                    <v-btn icon :disabled="showBtn" color="#000" size="20px" @click="plusBtn">
                        <v-icon small>mdi-plus-circle</v-icon>
                    </v-btn>
                </th>
                <th class="text-left table_text pa-3 pr-0"
                style="font-size: 14px;
                font-weight:400;">
                 <!-- v-if="assetInfo" -->
                    <v-row  v-for="(chip, index) in chips" :key="index">
                        <v-col cols="9">
                            <div>
                                <v-icon :color="chip.color" small class="mr-1">{{ getIcon(index) }}</v-icon>
                                <Chips  :chipText="chip.text" :ChipsColor="chip.color" />
                            </div>
                            <div class="bitrate_text mt-1">
                                <!-- <span style="font-size: 12px;">{{ chip.resolution }}<br > [{{ chip.size }}]</span> -->
                                <span style="font-size: 12px;">{{ chip.resolution }}{{ chip.size ? ' [' + chip.size + ']' : '' }}</span>
                            </div>
                        </v-col>
                        <v-col cols="1">
                            <v-btn x-small icon v-if="chip.size !== ''">
                                <v-icon small @click="deleteFile(chip)">mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </th> 
            </tr>
            <!-- <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    인코딩
                </th>
                <th class="text-left table_text pa-3"
                style="font-size: 14px;
                font-weight:400;">
                    <v-row>
                        <v-col>
                            <article>
                                <v-icon class="mr-1">mdi-monitor</v-icon>
                                <Chips chipText="1080p"/>
                            </article>
                            <article class="bitrate_text mt-1">1920x1080  [50MB]</article>
                        </v-col>
                        <v-col cols="1">
                            <v-btn x-small icon>
                                <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <article>
                                <v-icon class="mr-1">mdi-tablet</v-icon>
                                <Chips chipText="720p"/> 
                            </article>
                            <article class="bitrate_text mt-1">1280x720 [40MB]</article>
                        </v-col>
                        <v-col cols="1">
                            <v-btn x-small icon>
                                <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <article>
                                <v-icon class="mr-1">mdi-cellphone</v-icon>
                                <Chips chipText="360p"/>
                            </article>
                            <article class="bitrate_text mt-1">640x360  [30MB]</article>
                        </v-col>
                        <v-col cols="1">
                            <v-btn x-small icon>
                                <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </th>
            </tr> -->
            <tr class="table_wrap">
                <th class="text-left table_title pa-3"
                style="
                color: #000;
                font-size: 14px;
                width: 300px;">
                    {{ $store.getters.t('퍼블리싱') }}
                </th>
                <th class="text-left table_text"
                style="
                font-size: 14px;
                font-weight:400;">
                    <!-- <template>
                        <div class="switch-button" >
                            <div class="switch-handle"></div>
                        </div>
                    </template> -->
                    <CustomSwitch :switchState="switchState" :toggleSwitch="toggleSwitch"/>
                </th>
            </tr>
            <tr class="table_wrap">
                <th class="text-left table_title pa-3"
                style="
                color: #000;
                font-size: 14px;
                width: 300px;">
                    {{ $store.getters.t('보안') }}
                </th>
                <th class="text-left table_text"
                style="
                font-size: 14px;
                font-weight:400;">
                    <v-chip small v-if="assetInfo.secure" class="success_chip">ON</v-chip>
                    <v-chip small v-else disabled>OFF</v-chip>
                </th>
            </tr>
            <tr>
                <th class="text-left table_title pa-3"
                style="border-bottom: 1px solid rgb(0, 0, 0);
                color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('상세보기') }}
                </th>
                <th class="text-left table_line"
                style="border-bottom: 1px solid rgb(0, 0, 0);
                font-size: 14px;
                font-weight:400;">
                    <IconTextButtonoutline :buttonText="$store.getters.t('보기')" :buttonClick="editClick" :isDisabled="!isExists"/>
                </th>
            </tr>
        </thead>
    </template>
</v-simple-table>
        </div>

        

<AppSnackbar :snackbarText="snackbarText" :showSnackbar="showSnackbar" :timeout="timeout"></AppSnackbar>
            

</v-navigation-drawer>



</template>

<script>
import Chips from '@/components/ui/chips/Chips.vue';
import IconTextButtonoutline from '@/components/ui/button/IconTextButton_outline.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import { mapState, mapActions } from 'vuex';
import AppSnackbar from '../app/AppSnackbar.vue';
export default {
    components: {
        Chips,
        IconTextButtonoutline,
        CustomSwitch,
        AppSnackbar
    },
    props: {
        drawer: {
        type: Boolean,
        required: true
        },
        closeBtn: {
        type: Function,
        required: true
        },
        assetInfo: {
        type: Object,
        required: true,
        default: () => ({})
        },
        checkClick: {
        type: Function,
        required: true
        },
        editBtn: {
        type: Function,
        required: true,
        },
        delBtn: {
        type: Function,
        required: true,
        },
        load: {
        type: Boolean,
        required: true
        },
        playVideo: {
        type: Function,
        required: true,
        },
        resolutions: {
        type: Array
        },
        checkReq: {
            type: Boolean
        }
    },
    data(){
        return {
            res: [],
            found: false,
            temp01: [],
            temp02: [],
            temp03: [],
            keys: [],
            encodeInfo: [],
            sortOutInfo: [],
            // statusDatas: [],
            // statusInfo: [],
            size: null,
            // temp: null,
            snackbarText: null,
            showSnackbar: false,
            snackbarErrorText: null,
            showSnackbarError: false,
            timeout: null,
            check: this.$store.getters['objectData/getStandard']('checkData'),
            stateCheck: false,
            checkStatusVal: null,
            reqCheck: null,
        }
    },
    watch: {
        assetInfo: {
            async handler(newValue) {
                if (newValue) {
                    await this.fetchReqCheck();
                }
            },
            immediate: true 
        }
        // 'assetInfo.encodingInfo': {
        //     handler(newVal) {
        //             if (newVal !== null && typeof newVal !== 'undefined') {
        //                 this.encodeInfo = Object.values(newVal);
        //             }
        //         }
        //     },
        //     immediate: true, 
        //     deep: true 
        // },
        // 'assetInfo.map(e=>e.sortOut)': {
        //     handler(newVal) {
        //             if (this.load && this.dataLoad && this.assetInfo && newVal !== null && typeof newVal !== 'undefined') {
        //                 this.sortOutInfo = this.assetInfo.map(e => e.newVal);
        //             }
        //         }
        //     },
        //     immediate: true, 
        //     deep: true 
        // },
        // assetInfo: {
        //     handler(newValue, oldValue) {
        //     if (newValue) {
        //         this.dataLoad = false;
        //     }
        //     },
        //     immediate: true 
        // }
        // 'assetInfo.statusInfo': {
        //     handler(newVal) {
        //         if (newVal !== null && typeof newVal !== 'undefined') {
        //             // this.statusInfo = Object.values(newVal);
        //             console.log("newVal => ", newVal)
        //             // this.statusInfo = newVal.map(item => item.status);
            
        //     // console.log("statusInfo => ", this.statusInfo);
        //             // const data = Object.values(newVal.map(e => e));
        //             // console.log("statusInfo[data] => ", data);
        //             // this.statusInfo = data.map(item => {
        //             //     const key = Object.keys(item)[0];
        //             //     return itemyeon[key].status;
        //             // })
        //             // console.log("statusInfo => ", this.statusInfo);
        //         }
        //     },
        //     immediate: true, 
        //     deep: true 
        // },
        // 'assetInfo.types': {
        //     handler(newVal) {
        //         console.log("newVal ss=> ", newVal)
        //         // if (newVal !== null && typeof newVal !== 'undefined') {
        //         //     console.log("인코딩타입 => ", newVal)
        //         //     this.keys = Object.values(newVal);
        //         // }
        //     },
        //     immediate: true, 
        //     deep: true 
        // },
    },
    mounted() {
        if(this.assetInfo && this.dataLoad){
            this.fetchReqCheck();
            // console.log("assetInfo => ", this.assetInfo)
            // this.dataLoad = true;
            // const params = {
            //     asset_id: this.assetInfo.assetId
            // }
            // this.reqCheck = await this.checkEncoding(params);
            // console.log("reqCheck => ", this.reqCheck)
        }
    },
    computed: {
        ...mapState('asset', ['switchState', 'loading', 'dataLoad']),
        getImage(){
            if(this.load && this.dataLoad && this.assetInfo){
                return this.assetInfo.image ?? "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
            }
            return null;
        },
        // async reqCheck(){
        //     if(this.assetInfo){
        //         const params = {
        //             asset_id: this.assetInfo.assetId
        //         }
        //         return await this.checkEncoding(params);
        //     }
        // },
        isExists() {
            if(this.load && this.dataLoad && this.assetInfo){
                if(this.assetInfo.status === "abnormal" || this.assetInfo.status === "extract"){
                    return false;
                } else {
                    return true;
                }
            }
            return false;
        },
        // checkStatusVal(){
        //     if(this.load && this.dataLoad && this.assetInfo){
        //         if(this.assetInfo.status.includes('uploaded')){
        //             return 'upload';
        //         }
        //         else if(this.assetInfo.status.includes(/^encoded\s/)){
        //         // else if(this.assetInfo.status.match(/^encoded\s/)){
        //             return 'encoded';
        //         }
        //         else if(this.assetInfo.status === 'processing'){
        //             return 'processing';
        //         }
        //     }
        //     return null;
        // },
        chips() {
            if(this.load && this.dataLoad && this.assetInfo){
                return this.getChipData();
            }
            return null;
        },
        getIcon() {
            return (index) => {
                switch(index) {
                case '1080p':
                case 0:
                    return 'mdi-monitor';
                case '720p':
                case 1:
                    return 'mdi-tablet';
                case '480p':
                case 2:
                    return 'mdi-cellphone';
                default:
                    return '';
                }
            }
        },
        showBtn(){

            if(this.assetInfo){
                if(this.checkReq || this.reqCheck === 'yes' || this.assetInfo.status !== 'uploaded'){
                    return true;   // 비활성
                } else {
                    return false;  // 활성
                }
            }
            
            // console.log("this.assetInfo.encodingInfo => ", this.assetInfo);
            // // const check = this.assetInfo.sortOut.every(e => e.status === 'encoded');
            // const statusCheck = this.assetInfo.status
            // const check = this.assetInfo.encodingInfo && Array.isArray(this.assetInfo.encodingInfo) ? 
            // this.assetInfo.encodingInfo.every(e => e && e.status === 'encoded') : false;
            // const data = this.resolutions.map(e => e.label);
            // const isCheck = this.assetInfo.encodingInfo.some(e => data.includes(e.type));   // true면 포함 -> 버튼이 비활성화가 되야함

            // //console.log("isCheck1 => ", data)
            // //console.log("isCheck2 => ", this.assetInfo.encodingInfo.map(e=> e.type))
            // //console.log("isCheck3 => ", isCheck)

            // if(!check && !isCheck){
            //         return false;   // 버튼 활성
            //         // val = false;
            // }
            // else {
            //     return true;    // 버튼 비활성
            //     // val = true;
            // }
        },
        editClick: {
            get() {
                return this.editBtn;
            },
            set(val){
                return this.$emit('update:editBtn', val);
            }
        },
        // temp(){
        //     if(this.dataLoad && this.assetInfo){
        //         const ispubUn = this.assetInfo.encodeStatus;
        //         let status;
        //         if(ispubUn === "Published"){
        //             status = true;
        //         } 
        //         else {
        //             status = false;
        //         }
        //         this.$store.commit('asset/setSwitchState', status);
        //         return status;
        //     }
        //     return null;
        // },


                        

        // statusInfo: {
        //     // const data = Object.values(this.assetInfo.statusDatas.map(e => e));
        //     // console.log("statusInfo[1] => ", data);
        //     // const tmp = data.map(item => {
        //     //     const key = Object.keys(item)[0];
        //     //     return item[key].status;
        //     // })
        //     // console.log("statusDatas[2] => ", tmp);
        //     // return tmp
        //    get(){
        //         console.log("상태변화11 => ", this.assetInfo.statusInfo)
        //         if (this.assetInfo && this.assetInfo.statusInfo) {
        //             const tmp = this.assetInfo.statusInfo.map(item => item);
        //             console.log("상태변화 => ", tmp)
        //             return tmp;
        //         } else {
        //             return [];
        //         }
        //    },
        //    set(){

        //    }
        // },
        // types(){
        //     // if (this.assetInfo && this.assetInfo.encoding_type) {
        //     //     const tmp = this.assetInfo.encoding_type.map(item => item);
        //     //     console.log("인코딩 타입 => ", tmp);
        //     //     return tmp;
        //     // } else {
        //     //     return [];
        //     // }
        //     // console.log("gg => ", this.assetInfo)
        //     if (this.assetInfo && this.assetInfo.types) {
        //         const tmp = this.assetInfo.encoding_type.map(item => item);
        //         console.log("인코딩 타입1 => ", tmp);
        //         // const resolutions = tmp.map(item => {
        //         //     if (typeof item === 'string') {
        //         //         const resolution = item.split(' ')[0];
        //         //         console.log("인코딩 타입33 => ", resolution);
        //         //         return item.includes('(X)') ? [resolution, '!black'] : resolution;
        //         //     } else {
        //         //         return item;
        //         //     }
        //         // }).flat(); 
        //         // console.log("인코딩 타입2 => ", resolutions);
        //         // return resolutions;
        //     }
        // }
        // switchState: {
        //     get() {
        //         if (Object.values(this.encodeInfo).some(e => e.ispublish === "Unpublished")) {
        //             return false;
        //         } else {
        //             return true;
        //         }
        //     },
        //     set(value){
        //         return value
        //     }
        // }
    },
    methods: {
        ...mapActions('asset', ['updateDistribution', 'checkEncoding']),
        drawer_Btn(){
            this.closeBtn();
        },
        async fetchReqCheck(){
            if(this.assetInfo){
                const params = {
                    asset_id: this.assetInfo.assetId
                }
                this.reqCheck = await this.checkEncoding(params);
            }
        },
        codecCheck(){
            if(this.assetInfo?.upload_v_codec !== 'h264' && (this.assetInfo?.status === 'uploaded' || this.assetInfo?.status === 'processing')){
                return true;
            } else if((this.assetInfo?.status === 'h264' || this.assetInfo?.status !== 'h264') && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('encoded'))){
                return false;
            }
        },
        updateType(val) {
            return val.toString().split(" ")[0];
        },
        
        getChipData() {
            if(this.load && this.dataLoad && this.assetInfo){
                // console.log(this.assetInfo)
                
                const ispub = this.assetInfo?.encoding_status ;
                // const a = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing';
                // const b = (this.assetInfo?.upload_v_codec === 'h264' || this.assetInfo?.upload_v_codec !== 'h264') && this.assetInfo?.status.includes('encoded');
                this.checkStatusVal = this.assetInfo?.status;

                /*
                    # 재생조건
                        . uploaded & encoded 상관없음
                        . h264 코덱
                        . h264 코덱이 아니여도 status가 encoded이면 됨
                        
                        위의 3가지 조건은 encoding_status가 published이면서 status가 processing이 아니여야함
                */
                const a = this.assetInfo?.encoding_status === 'Published' && this.assetInfo?.status !== 'processing';
                const b = this.assetInfo?.upload_v_codec === 'h264' && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('uploaded'));
                const c = this.assetInfo?.upload_v_codec !== 'h264' && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('encoded'));
                const d = this.assetInfo?.upload_v_codec === 'h264' && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('encoded'));

                this.stateCheck = false;
                if(a){
                    if(b){
                        this.stateCheck = true;
                    }
                    if(c){
                        this.stateCheck = true;
                    }
                    if(d){
                        this.stateCheck = true;
                    }
                } else {
                    this.stateCheck = false;
                }


                let status;
                if (ispub === 'Published') {
                    status = true;
                } 
                else {
                    status = false;
                }
                this.$store.commit('asset/setSwitchState', status);

                let res = [];
                // let colors = [];
                // let texts = [];
                // let sizes = [];
                // let resolutions = [];
                const datas = this.assetInfo.encodingInfo;

                res = datas.map(e => ({
                    // text: e.type === 'processing' ? 'processing' : this.updateType(e.type),
                    id: e.id,
                    text: e.type !== null && e.type !== undefined ? this.updateType(e.type) : '',
                    color: e.status === 'encoded' ? 'black' : e.status,
                    size: e.size ? e.size : '',
                    resolution: e.resolution ? e.resolution : '',
                }));
                // datas.forEach(e => {
                //     texts.push(e.type === 'processing' ? 'processing' : this.updateType(e.type));
                //     colors.push(e.status === 'encoded' ? 'black' : e.status);
                //     sizes.push(e.size ? e.size : null);
                //     resolutions.push(e.resolution ? e.resolution : null);
                // });

                // res.push({
                //     text: texts, 
                //     color: colors,
                //     size: sizes,
                //     resolution: resolutions,
                // });
                // let color = datas.map(e => e.status) === 'encoded'? 'black' : datas.map(e => e.status);
                // let text = datas.map(e => e.type) === 'processing' ? 'processing' : this.updateType( datas.map(e => e.type));
                // let size = datas.map(e => e.size) ? datas.map(e => e.size) : null;
                // let resolution = datas.map(e => e.resolution) ? datas.map(e => e.resolution) : null;
                // res.push({
                //     text: text,
                //     color: color,
                //     size: size,
                //     resolution: resolution,
                // });

                // this.temp01 = this.assetInfo;
                // this.temp02 = this.temp01.types;
                // this.temp03 = this.temp01.encodingInfo;
                
                // const keys = Object.keys(this.temp03);
                // const vals = Object.values(this.temp03).map((value, index) => ({ ...value, type: keys[index] }));

                // const merge = vals.map(e => {
                //     const data = this.temp02.find(item => item.resolution === e.type);
                    
                //     if (data) {
                //         return {
                //             ...e,
                //             types: data.resolution,
                //             status: data.status
                //         };
                //     } else {
                //         return null; 
                //     }
                // }).filter(item => item !== null); 

                // let res = [];
                // for (const item of this.check) {
                //     const tempData = merge.find(e => e.types.includes(item));
                //     let text = tempData ? tempData.types : item;
                //     let color = tempData && tempData.status === 'encoded' ? 'black' : '!black';
                //     res.push({
                //         text: text,
                //         color: color,
                //         size: tempData ? tempData.size : null,
                //         resolution: tempData ? tempData.resolution : null,
                //         id: tempData ? tempData.id : null
                //     });
                // }

                this.res = res;


                //console.log("결과 => ", this.res);
                return this.res;
            }

        },
        plusBtn(){
            this.checkClick();
        },
        async toggleSwitch(){
            if(this.load && this.dataLoad && this.assetInfo){
                //console.log("토글전?" , this.switchState)
                const newState = !this.switchState;

                // const smil_url = this.encodeInfo.map(item => {
                //     const key = Object.keys(item)[0];
                //     return item[key].smil_url;
                // });
                // const folder = this.checkStatusVal === 'uploaded' ? 'upload' : 'encoded';
                // console.log("checkStatusVal => ", this.assetInfo.status)
                const params = {
                    id: this.assetInfo.assetId,
                    aid: this.assetInfo.aid,
                    type: this.switchState ? 'unpub' : 'pub',
                    smil_url: this.assetInfo.smil_url,
                    newState: newState,
                    folder: this.checkStatusVal,
                };
                this.$store.commit('asset/setSwitchState', newState);
                const res = await this.updateDistribution(params);
                this.timeout = 2000;
                if(res !== 1){
                    this.$store.commit('asset/setSwitchState', !newState);
                }
                this.$store.commit('asset/setDrawer', false);
                this.$emit('reload-data'); 
                // this.$router.go();

                //console.log("토글후?" , this.switchState)
            }
        },
        openPlayer(){
           return this.playVideo();
        },
        deleteFile(index){
            this.delBtn(index.id);
        },
        closeVideo(){
            //console.log("close")
            this.playVal = false;
        },
        // stateCheck(){
        //     // return this.assetInfo.sortOut.some(e => e.status === 'encoded');
        //     const check = this.assetInfo && this.assetInfo.encodeStatus && this.assetInfo.encodeStatus === 'Published';
        //     // console.log("여기 확인 => ",check)

        //     if (check) {
        //         this.stateCheck = true;
        //     } else {
        //         this.stateCheck = false;
        //     }
        // }

        
    },
}
</script>

<style>
.drawer_btn { position: absolute;margin: 30px 0px 0px -28px;background: #fff;border: 1px solid;border-color: #ddd #fff #ddd #ddd; }
.v-navigation-drawer { overflow: visible; }
.imageInfo-container {
    position: relative; 
    background-color: black;
    width: 230px;
    height: 130px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    overflow: hidden;
    border-radius: 8px;
}
.imageInfo {
    position: absolute;
    height: 100%;
    top: 0;
    object-fit: contain;
    object-position: top center;
    padding: 0;
}
.text-left {
    width:100px !important;
}
.overlay_wrap{
    width: 100%;
    height: 100%;
    background: rgba(255, 74, 74, 0.4);
}
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width:100%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.overlay v-icon {
  font-size: 48px;
  color: white;
  cursor: pointer;
}

.success_chip {
    background: #efffe4 !important;
    color: green !important;
}
</style>